import loadable from 'utils/loadable';

export const Main = loadable(
  () => import('./Main.container'),
  module => module.Main,
);

export const Header = loadable(
  () => import('./Header.jsx'),
  module => module.Header,
);

export const HeaderImage = loadable(
  () => import('./HeaderImage.jsx'),
  module => module.HeaderImage,
);

export const HeaderUtils = loadable(
  () => import('./Header-Utils'),
  module => module.HeaderUtils,
);

export const HeaderLogo = loadable(
  () => import('./Header-Logo'),
  module => module.HeaderLogo,
);

export const Intro = loadable(
  () => import('./Intro'),
  module => module.Intro,
);

export const Applications = loadable(
  () => import('./Applications'),
  module => module.Applications,
);

export const Categories = loadable(
  () => import('./Categories'),
  module => module.Categories,
);

export const MainContent = loadable(
  () => import('./MainContent'),
  module => module.MainContent,
);

export const DialogPr = loadable(
  () => import('./DialogPr'),
  module => module.DialogPr,
);
